import axios from 'axios';


const baseURL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL,
});



// Função para definir o token de autenticação no header
const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};


// Recuperar o token do localStorage e definir no Axios
const token = localStorage.getItem('authToken');
setAuthToken(token);

// Interceptor de requisição: anexa o token mais recente
api.interceptors.request.use(
  (config) => {
    try {
      config.headers = config.headers || {};

      // 🔹 Sempre envia o tenant
      const tenantId = getTenantId();
      if (tenantId) {
        config.headers['x-tenant-id'] = tenantId;
      }

      // 🔹 Só envia Authorization se existir token
      const currentToken = localStorage.getItem('authToken');
      if (currentToken) {
        config.headers['Authorization'] = `Bearer ${currentToken}`;
      }
    } catch (e) {
      // silencioso
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de resposta: trata 401/403 (token inválido/expirado)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      // Usuário não autenticado → limpa token e redireciona para login
      try {
        localStorage.removeItem('authToken');
      } catch (_) {
        // ignore
      }
      if (typeof window !== 'undefined' && window.location?.pathname !== '/login') {
        setTimeout(() => {
          window.location.href = '/login';
        }, 0);
      }
    } else if (status === 403) {
      // Usuário autenticado, mas sem permissão → mantém na página atual
      console.warn('Usuário não possui permissão para acessar este recurso.');
      // opcional: você pode mostrar um toast ou modal de "Acesso negado"
    }

    return Promise.reject(error);
  }
);


export default api;

// Funções de autenticação
export const login = async (username, password) => {
  try {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Funções para gerenciar pessoas
/*export const getPessoas = () => {
  return api.get('/pessoas');
};*/

export const getFornecedores = async (filters = {}) => {
  try {
    const response = await api.get('/fornecedores', { params: filters });
    return response;
  } catch (error) {
    console.error('Erro ao buscar fornecedores:', error);
    throw error; // Repassa o erro para tratamento
  }
};

// Funções para gerenciar Clientes
export const getClientes = async (filters = {}) => {
  try {
    const response = await api.get('/clientes', { params: filters });

    // Tratamento especial para status 412 (que não é considerado erro)
    if (response.status === 412) {
      return {
        ...response,
        data: [] // Garante que retornará um array vazio
      };
    }

    // Para outros status de sucesso (como 200)
    return response;

  } catch (error) {
    // Só trata como erro real se não for 412
    if (error.response && error.response.status === 412) {
      return {
        ...error.response,
        data: [] // Retorna array vazio para 412
      };
    }

    console.error('Erro ao buscar clientes:', error);
    throw error; // Repassa outros erros para tratamento
  }
};

// Get Empresa
export const getEmpresaById = async (id) => {
  return api.get(`/empresa/${id}`);
};

//Funções cliente
export const addCliente = async (cliente) => {
  return api.post('/clientes', cliente);
};

// Funções para gerenciar produtos
export const getProdutos = async (filters = {}) => {
  try {
    // Valores padrão para paginação
    const params = {
      page: 1,
      pageSize: 10,
      ...filters
    };

    // Validação básica dos parâmetros
    if (params.page && (isNaN(params.page) || params.page < 1)) {
      throw new Error('O parâmetro "page" deve ser um número maior que 0');
    }

    if (params.pageSize && (isNaN(params.pageSize) || params.pageSize < 1)) {
      throw new Error('O parâmetro "pageSize" deve ser um número maior que 0');
    }

    const response = await api.get('/produtos', { params });

    // Retorna tanto os dados quanto os metadados de paginação
    return {
      data: response.data.data, // Array de produtos
      pagination: response.data.pagination // Metadados de paginação
    };
  } catch (error) {
    console.error('Erro ao buscar produtos:', error);

    // Para erros de resposta da API, retornamos o erro completo
    if (error.response) {
      throw {
        status: error.response.status,
        message: error.response.data.erro || 'Erro ao buscar produtos',
        details: error.response.data.detalhes
      };
    }

    // Para outros tipos de erros (como os de validação acima)
    throw {
      status: 400,
      message: error.message
    };
  }
};



// Vendas
export const registravenda = async (venda) => {
  return api.post('/vendas', venda);
};

export const consultaVenda = async (filterData = {}) => {
  try {
    const response = await api.get('/vendas', {
      params: filterData
    });
    return response;
  } catch (error) {
    console.error("Erro ao consultar vendas:", error);
    throw error; // rethrow para permitir que quem chamou trate também
  } finally {
    // Coloque aqui qualquer lógica de limpeza, se necessário
  }
};


export const consultaVendaPorId = async (id) => {
  return api.get(`/vendasid/${id}`);
};

export const consultaItensVenda = async (id) => {
  return api.get(`/vendas/${id}`);
};

export const statusNfe = async (id) => {
  try {
    const response = await api.get(`/nfe-status/${id}`);
    return response.data; // Retorna os dados do status
  } catch (error) {
    console.error('Erro ao buscar status NFe por ID:', error);
    throw error; // Lança o erro para tratamento em outro lugar
  }
}

export const getDanfe = async (id) => {
  try {
    const response = await api.get(`/geradanfe/${id}`, {
      responseType: 'blob' // PDF binário
    });

    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);

  } catch (error) {
    if (error.response?.status === 412) {
      alert('Não é possível gerar a DANFE NFC-e: esta venda foi emitida como NF-e (modelo 55).');
      return;
    }

    console.error('Erro ao buscar DANFE NFC-e por ID:', error);
    alert('Erro inesperado ao gerar DANFE NFC-e.');
  }
};



export const geraNFC = async (id) => {
  try {
    const response = await api.get(`/geranfc/${id}`, {
      validateStatus: function (status) {
        return true; // Aceita qualquer status e permite você tratar no .status depois
      }
    });
    return response;
  } catch (error) {
    console.error('Erro ao buscar XML por ID:', error);
    throw error;
  }
};


export const retornaXMLAssinado = async (id, xmlString) => {
  return api.put(`/returnoxmlassinado/${id}`, xmlString, {
    headers: {
      'Content-Type': 'application/xml' // ou 'text/xml'
    }
  });
};

// Lancamentos
export const registraLancamento = async (lancto) => {
  return api.post('/lancamentos', lancto);
};

export const consultaLancamentos = async () => {
  return api.get('/lancamentos');
};

export const consultaLancamentosById = async (id) => {
  return api.get(`/lancamentos/${id}`);
};

// Consulta de Pagamentos Por Id da Venda
export const consultaPagamentosById = async (id) => {
  return api.get(`/pagamentos/${id}`);
};


// UFs e Municípios
export const getUfs = async () => {
  return api.get('/uf');
};

export const getMunicipiosUfId = async (id) => {
  return api.get(`/municipios/${id}`);
};

export const getMunicipios = async (id) => {
  return api.get(`/municipios/${id}`);
};

export const getMunicipiosIBGE = async (id, codMunIBGE) => {
  return api.get(`/municipios/mun/${id}`, codMunIBGE);
};

export const getUFIBGE = async (id, codIBGE) => {
  return api.get(`/uf/uf/${id}`, codIBGE);
};


// Formas de Pagamentos

export const getFormasPagamento = async (filtro = {}) => {
  try {
    const response = await api.get('/formas-pagamento', { params: filtro });
    return response
  } catch (error) {
    console.error('Erro ao buscar formas de pagamento:', error);
    throw error;
  }
};


// 🔥 Detecta tenant pelo subdomínio
const getTenantId = () => {
  try {
    if (typeof window === 'undefined') return null;

    const host = window.location.hostname;

    // localhost ou IP → fallback para env
    if (
      host.match(/^\d+\.\d+\.\d+\.\d+$/)
    ) {
      return process.env.REACT_APP_TENANT_ID || null;
    }

    // pega o subdomínio
    const parts = host.split('.');

    // celeiro.sessoftware.com.br → celeiro
    if (parts.length >= 2) {
      return parts[0];
    }

    return process.env.REACT_APP_TENANT_ID || null;
  } catch {
    return null;
  }
};